import { useEffect } from "react";
import { useSnapshot } from "valtio";
import { state } from "../context/store";
import { cameraConfigs } from "../context/cameraConfigs";

export const useCameraAutoFocus = (cameraControlsRef) => {
  const snap = useSnapshot(state.current);
  const page = snap.currentStep;

  const currentModel = snap.initialChoices.threeDModel; // adjust to your state shape

  if (!currentModel) return;

  // console.log(
  //   "useCameraAutoFocus - page:",
  //   page,
  //   "currentModel:",
  //   currentModel,
  // );
  useEffect(() => {
    if (!state.current.autoCamera) return;

    const stepName = state.current.steps[page].name;
    const modelConfig = cameraConfigs[currentModel] ?? cameraConfigs.motorcycle;
    const stepConfig = modelConfig[stepName] ?? modelConfig.default;

    if (!stepConfig) return;
    if (stepConfig.condition && !stepConfig.condition(snap)) return;

    const [px, py, pz] = stepConfig.position;
    const [tx, ty, tz] = stepConfig.target;
    cameraControlsRef.current?.setLookAt(px, py, pz, tx, ty, tz, true);
  }, [page, currentModel]);
};
